module.exports = __webpack_public_path__ + "img/verena.24490eee.png";